import { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";
import {
  salesInvoiceTableAction,
  salesInvoiceViewAction,
  salesInvoiceVoidAction,
} from "../../../redux/actions/sales-action";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../../components/helper-components/success-toast";
import errorToast from "../../../components/helper-components/error-toast";
import { handlea4Print } from "../../../components/helper-components/helper-function";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import SalesPurchaseFilter from "../../../components/sales-section/sales-purchase-filter";
import BadgesComponent from "../../../components/tables/badges-component";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import ChartIncreaseIcon from "../../../assets/icons/sales-icons/chart-increase-icon";
import ClockIcon from "../../../assets/icons/sales-icons/clock-icon";
import FilmChartIcon from "../../../assets/icons/sales-icons/film-chart-icon";
import ArrowDownLeftIcon from "../../../assets/icons/sales-icons/arrow-down-left-icon";
const SalesInvoice = () => {
  const [heading, setHeading] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState([]);
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  const [reload, setReload] = useState(false);
  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const grnData = parsed.find((obj) => obj?.sales_invoice_list);
      if (grnData?.sales_invoice_list) {
        setHeading(grnData.sales_invoice_list);
      }
    }
  }, []);
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => { };
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "soit_invoice_number",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });
  useEffect(() => {
    dispatch(
      salesInvoiceTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const initialFilter = {
    sort_by: "",
    sort_order: "",
    selectColumn: "soit_invoice_number",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  };
  function sortFn(item) {
    let direction = "ASC";
    if (
      filterData != null &&
      filterData?.sort_by === item &&
      filterData?.sort_order === "ASC"
    ) {
      direction = "DESC";
    }
    setFilterData({ ...filterData, sort_by: item, sort_order: direction });
  }

  const isItemChecked = (rowData) => {
    return invoiceItems.some(
      (item) =>
        item.soit_id === rowData.id &&
        item.cmr_id === rowData.cmr_id &&
        Object.keys(item).length === 2
    );
  };
  const handleCheckboxChange = (e, rowData) => {
    if (e.target.checked) {
      setInvoiceItems((prevItems) => [
        ...prevItems,
        {
          soit_id: rowData.id,
          cmr_id: rowData.cmr_id,
        },
      ]);
    } else {
      setInvoiceItems((prevItems) =>
        prevItems.filter(
          (item) =>
            !(
              item.soit_id === rowData.id &&
              item.cmr_id === rowData.cmr_id &&
              Object.keys(item).length === 2
            )
        )
      );
    }
  };

  function itemsChecker(e, rowData) {
    const id = e.target.id;
    if (e.target.checked) {
      setInvoiceItems((prevItems) => [
        ...prevItems,
        {
          soit_id: rowData.id,
          item_id: id,
          cmr_id: rowData.cmr_id,
        },
      ]);
    } else {
      setInvoiceItems((prevItems) =>
        prevItems.filter(
          (item) =>
            !(
              item.soit_id === rowData.id &&
              item.item_id === id &&
              item.cmr_id === rowData.cmr_id
            )
        )
      );
    }
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);
  const toggleRow = (index, id) => {
    if (
      invoiceItems?.some((item) => item?.soit_id === id) &&
      Object.keys(invoiceItems?.find((item) => item?.soit_id === id)).length ===
      2
    ) {
      setInvoiceItems(invoiceItems?.filter((item) => item?.soit_id !== id));
    }
    if (
      invoiceItems?.some((item) => item?.soit_id === id) &&
      Object.keys(invoiceItems?.find((item) => item?.soit_id === id))
        ?.length === 3
    ) {
      setInvoiceItems(invoiceItems?.filter((item) => item?.soit_id !== id));
    }
    setItemLoading(true);
    if (expandedRows.includes(index)) {
      setExpandedRows((prevRows) => prevRows.filter((row) => row !== index));
    } else {
      setExpandedRows((prevRows) => [...prevRows, index]);
      dispatch(
        salesInvoiceViewAction(
          id,
          (data) => {
            setOrders((prevOrders) =>
              prevOrders.map((order) =>
                order.soit_id === id
                  ? { ...order, itemData: data?.data?.[0]?.itemData ?? [] }
                  : order
              )
            );
            setItemLoading(false);
          },
          onErrPur
        )
      );
    }
  };
  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.soit_id,
      soit_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.soit_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      soit_custom_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.soit_custom_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      soit_order_date: moment(item?.soit_order_date).isValid() ? moment(item.soit_order_date).format("MMM D, YYYY") : "--",
      cmr_name: item?.cmr_name ?? "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      order_status: <BadgesComponent status={item?.soit_order_status} />,
      // (
      //   <span
      //     className={`${
      //       item?.soit_order_status === "closed"
      //         ? "text-027A48 border-027A48 border"
      //         : item?.soit_order_status === "cancelled"
      //         ? "border-f51d00 border text-F51D00"
      //         : "border-344054 border text-344054"
      //     } px-2 py-1 rounded-full text-xs whitespace-nowrap`}
      //   >
      //     {formatString(item?.soit_order_status)}
      //   </span>
      // ),
      // item?.soit_order_status === "open"
      //   ? "Open"
      //   : item?.soit_order_status === "closed"
      //   ? "Closed"
      //   : "Cancelled",
      soit_total_amount: "₹ " + item?.soit_total_amount,
      is_draft_order: item?.is_draft_order,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      cmr_id: item?.cmr_id ?? "--",
      soit_order_status: item?.soit_order_status ?? "",
      soit_order_date: moment(item?.soit_order_date).isValid() ? moment(item.soit_order_date).format("MMM D, YYYY") : "--"

    };
  });

  const onErrPur = (data) => {
    setItemLoading(false);
  };
  const removeItemData = (id) => {
    const order = orders.find((item) => item.soit_id === id);
    if (order) {
      const updatedOrders = orders.map((item) => {
        if (item.soit_id === id) {
          return {
            ...item,
            itemData: [],
          };
        }
        return item;
      });
      setOrders(updatedOrders);
    }
  };
  function printFn(id) {
    handlea4Print(id, "sales_invoice", dispatch);
  }

  function eWayBillFn(id) {
    navigate(`/add-e-way-bill/${id}`);
  }

  function voidFn(id) {
    dispatch(
      salesInvoiceVoidAction(
        {
          soit_id: id,
        },
        (data) => {
          setReload(!reload);
          successToast(data?.message);
          setItemLoading(false);
        },
        (data) => {
          errorToast(
            <p>
              {data?.data?.message}
              {data?.data?.data?.map((invoice) => (
                <div>
                  {invoice?.sct_invoice_number ?? invoice?.soit_invoice_number}
                </div>
              ))}
            </p>
          );
        }
      )
    );
  }
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".head-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [loading]);
  const filterby = showFilter ? (
    <SalesPurchaseFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Qty invoiced Units",
      value: `${0}`, //backend
      desc: `₹${0} Lakhs`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <ArrowDownLeftIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. Invoice Value",
      value: `₹${0} `, //backend
      desc: `+${0}% vs last week`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: <FilmChartIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending Invoices",
      value: 0, //backend
      desc: `₹${0} Lakh pending`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <ClockIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total sale Invoices",
      value: 0,
      desc: `+${0}% vs last month`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <ChartIncreaseIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];
  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      onclkFn={() => {
        navigate(
          `/add-sales-invoice/${encodeURIComponent(JSON.stringify([]))}/invoice`
        );
      }}
      title="Sales Invoice"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            ViewAction={salesInvoiceViewAction}
            transaction="Sales Invoice"
            transaction_type="sales_invoice"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={invoiceItems}
            options={options}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-sales-invoice/${id}`)}
            list={true}
            onclkFn={() => {
              navigate(
                `/add-sales-invoice/${encodeURIComponent(
                  JSON.stringify([])
                )}/invoice?new`
              );
            }}
            cloneFn={(id) => {
              navigate(
                `/add-sales-invoice/${encodeURIComponent(
                  JSON.stringify([])
                )}/invoice?cloneID=${id}`
              );
            }}
            permissionFn={permissionFn}
            module={"sales_invoice"}
            path="sales-invoice"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={salesInvoiceVoidAction}
            label="Sales Invoice"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "soit_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              orderStatus: "",
            }}
            handleSelect={(item) => {
              if (item?.value === "sales_credit_note") {
                navigate(
                  `/add-sales-credit-note/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/invoice`
                );
              } else {
                navigate("/add-sales-payment-in");
              }
            }}
            transactionKey="soit"
            eWayBillFn={eWayBillFn}
            actionsPermissions={{
              edit: ["draft"], // Edit allowed for "open" and "draft"
              delete: ["open", "draft"], // Delete allowed only for "open"
              print: ["open", "closed", "draft"], // Print allowed for "open" and "closed"
              send: ["open", "closed", "draft"], // Share allowed for "open" and "closed"
              clone: ["open", "closed", "draft"],
              ewaybill: ["open", "closed"], // E-Way Bill for "open" and "closed"
            }}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default SalesInvoice;
const tableHeading = [
  {
    label: "SALES INVOICE NUMBER",
    value: "soit_invoice_number",
    display: true,
    column: true,
  },
  {
    label: "CUSTOM SI NUMBER",
    value: "soit_invoice_number",
    display: true,
    column: true,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_name",
    display: true,
    column: true,
  },
  { label: "DATE", value: "update_date", display: true, column: false },
  {
    label: "DOCUMENT DATE",
    value: "soit_order_date",
    display: true,
    column: false,
  },
  {
    label: "ORDER STATUS",
    value: "order_status",
    display: false,
    column: false,
  },
  {
    label: <span className="flex justify-end">AMOUNT</span>,
    value: "soit_total_amount",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  { label: "", value: "", column: false },
];

const tableHeading1 = [
  { label: "PRODUCT NAME", value: "item_name" },
  { label: "GENERIC NAME", value: "item_generic_name" },
  { label: "ITEM CODE", value: "item_code" },
  { label: "UOM", value: "item_uom" },
  { label: "PRICE (₹)", value: "item_unit_price" },
  { label: "QTY", value: "item_quantity" },
  {
    label: "CREDIT REMAINING QTY",
    value: "item_credit_quanity_remaining",
  },
  { label: "TOTAL (₹)", value: "item_total_amount" },
];

const options = [
  { value: "sales_credit_note", label: "Sales credit Note" },
  // { value: "payment_in", label: "Payment In" },
];
